import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import SelectResearchers from './../FormControls/SelectResearchers';
import SelectAsyncCustom from './../FormControls/SelectAsyncCustom';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { ResearcherForm } from '../ResearcherForm';
import DatePicker from "react-datepicker";

import TextArea from '../Researcher/TextArea';

import * as Constants from '../../Constants';
import InputText from '../InputText';

import "react-datepicker/dist/react-datepicker.css";

const ConsultationTypes = {
    issueReferred: 'issueReferred',
    consultationResearcher: 'consultationResearcher',
    studyDevelopmentAssistance: 'studyDevelopmentAssistance',
    researchCollaborators: 'researchCollaborators',
    researchSiteCollaboration: 'researchSiteCollaboration',
    clinicalTrialAssistance: 'clinicalTrialAssistance',
    clinicalTrialsGovAssistance: 'clinicalTrialsGovAssistance',
    regulatoryGuidance: 'regulatoryGuidance',
    biostatisticsAssistance: 'biostatisticsAssistance'
};

export class ContactForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loadingContact: props.type == 'edit',
            persons: [],
            contactDate: new Date(),
            resolutionDate: null,
            respondent: null,
            activityType: null,
            selectedActivity: '',
            consultationType: null,
            selectedConsultationId: '',
            outreachEvent: null,
            outreachComment: '',
            nctNumber: '',
            nctNumberStudyName: '',
            comment: '',
            dialogOpen: false,
            submissionSuccess: false,
            submissionError: false,
            loadResearcherError: false,
            shouldReloadPersons: false,
            onSubmitCallback: props.onSubmit,
            researcherId: props.researcherId,
            contactId: props.contactId,
            [ConsultationTypes.issueReferred]: [],
            [ConsultationTypes.consultationResearcher]: '',
            [ConsultationTypes.studyDevelopmentAssistance]: [],
            [ConsultationTypes.researchCollaborators]: '',
            [ConsultationTypes.researchSiteCollaboration]: [],
            [ConsultationTypes.clinicalTrialAssistance]: '',
            [ConsultationTypes.clinicalTrialsGovAssistance]: [],
            [ConsultationTypes.regulatoryGuidance]: [],
            [ConsultationTypes.biostatisticsAssistance]: [],
            respondents: [],
            crtuRequest: [],
            researchMatchRequest: [],
            addAnotherCallback: props.onAddAnother,
            formOpen: false
        };

        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleDialogOpen = this.handleDialogOpen.bind(this);
        this.handleDialogClose = this.handleDialogClose.bind(this);
        this.handleContactDateChanged = this.handleContactDateChanged.bind(this);
        this.handleResolutionDateChanged = this.handleResolutionDateChanged.bind(this);
        this.handlePersonsChanged = this.handlePersonsChanged.bind(this);
        this.handleResearcherAdded = this.handleResearcherAdded.bind(this);
        this.handleInputStringChange = this.handleInputStringChange.bind(this);
        this.loadContact = this.loadContact.bind(this);
        this.renderForm = this.renderForm.bind(this);
    }

    componentDidMount() {
        if (this.state.researcherId) {
            // pre-fill Researchers list with researcher
            this.loadResearcher(this.state.researcherId);
        }

        if (this.state.contactId) {
            this.loadContact(this.state.contactId);
        }
    }

    loadResearcher(researcherId) {
        if (!researcherId) {
            console.error('Invalid researcher id:', researcherId);
        }

        var url = new URL('/api/contacts/get-researcher', window.location.origin);
        var fetchParams = { id: researcherId };

        url.search = new URLSearchParams(fetchParams).toString();

        fetch(url)
            .then(response => {
                if (response.ok) {
                    return response.json();
                } else {
                    console.error('Failed to get researcher:', response);
                }
            })
            .then(json => {
                console.log('Loaded researcher', json);

                var persons = [
                    json
                ];

                this.setState({
                    persons: persons
                });
            })
            .catch(err => {
                console.log('Failed to fetch researcher');
            });
    }

    loadContact(contactId) {
        if (!contactId) {
            console.error('Invalid contact id:', contactId);
        }

        var url = new URL('/api/contacts/get-contact-vm', window.location.origin);
        var fetchParams = { id: contactId };

        url.search = new URLSearchParams(fetchParams).toString();

        fetch(url)
            .then(response => {
                if (response.ok) {
                    return response.json();
                } else {
                    console.error('Failed to get contact:', response);
                    this.setState({ loadContactError: true, loadingContact: false });
                }
            })
            .then(json => {
                this.setState({
                    id: json.id,
                    persons: json.persons,
                    contactDate: json.contactDate ? new Date(json.contactDate) : '',
                    resolutionDate: json.resolutionDate ? new Date(json.resolutionDate) : '',
                    respondent: json.respondent,
                    activityType: json.activityType,
                    selectedActivity: '',
                    consultationType: json.consultationType,
                    outreachEvent: json.outreachEvent,
                    outreachComment: json.outreachComment || '',
                    nctNumber: json.nctNumber || '',
                    nctNumberStudyName: json.nctNumberStudyName || '',
                    crtuRequest: json.crtuRequest,
                    researchMatchRequest: json.researchMatchRequest,
                    comment: json.comment || '',
                    [ConsultationTypes.issueReferred]: json[ConsultationTypes.issueReferred],
                    [ConsultationTypes.consultationResearcher]: json[ConsultationTypes.consultationResearcher],
                    [ConsultationTypes.studyDevelopmentAssistance]: json[ConsultationTypes.studyDevelopmentAssistance],
                    [ConsultationTypes.researchCollaborators]: json[ConsultationTypes.researchCollaborators],
                    [ConsultationTypes.researchSiteCollaboration]: json[ConsultationTypes.researchSiteCollaboration],
                    [ConsultationTypes.clinicalTrialAssistance]: json[ConsultationTypes.clinicalTrialAssistance],
                    [ConsultationTypes.clinicalTrialsGovAssistance]: json[ConsultationTypes.clinicalTrialsGovAssistance],
                    [ConsultationTypes.regulatoryGuidance]: json[ConsultationTypes.regulatoryGuidance],
                    [ConsultationTypes.biostatisticsAssistance]: json[ConsultationTypes.biostatisticsAssistance],
                    respondents: json.respondents,
                    loadingContact: false
                });
            })
            .catch(err => {
                console.log('Failed to fetch contact');
                this.setState({ loadContactError: true, loadingContact: false });
            });
    }

    getContactId() {
        const params = new URLSearchParams(window.location.search);

        return params.get('id');
    }

    handleFormSubmit(e) {
        e.preventDefault();

        console.log('Submitting', this.state);
        //JSON.stringify converts the date to UTC format and backend does not respect this.  The backend should respect this or this conversion there.
        if (this.state.contactDate) {
            this.state.contactDate = new Date(this.state.contactDate.getTime() - (new Date().getTimezoneOffset() * 60 * 1000));
        }
        if (this.state.resolutionDate) {
            this.state.resolutionDate = new Date(this.state.resolutionDate.getTime() - (new Date().getTimezoneOffset() * 60 * 1000));
        }

        fetch('/api/contacts/save-contact', {
            method: "POST",
            body: JSON.stringify(this.state),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
        }).then(response => {
            response.json().then(data => {
                if (response.ok) {
                    console.log("Submission success", data);
                    this.setState({ submissionSuccess: true });
                    if (this.state.onSubmitCallback) {
                        this.state.onSubmitCallback(data);
                    }
                } else {
                    console.error("Submission error", response);
                    this.setState({ submissionError: true });
                }
            })
        });
    }

    handleAddAnother = () => {
        this.setState({ formOpen: true });
    };

    handlePersonsChanged(e) {
        console.log(e);
        this.setState({ persons: e })
    }

    handleResearcherAdded(person) {
        person.value = person.id;

        console.log("handleResearcherAdded", person);

        let persons = this.state.persons;
        persons.push(person);
        this.setState({
            persons: persons,
            shouldReloadPersons: !this.state.shouldReloadPersons,
            formOpen: false
        });
    }

    handleAddNewResearcher() {
        this.setState({ showAddnewResearcherModal: !this.state.showAddnewResearcherModal })
    }

    handleContactDateChanged(e) {
        this.setState({ contactDate: e });
    }

    handleResolutionDateChanged(e) {
        this.setState({ resolutionDate: e });
    }

    handleInputStringChange(e) {
        const value = e.target.value;
        const name = e.target.name;

        this.setState({
            [name]: value
        });
    }

    handleDialogOpen = () => {
        this.setState({ dialogOpen: true, formOpen: true });
    };

    handleDialogClose = () => {
        if (this.state.formOpen) {
            if (window.confirm("Are you sure you want to close the Add Researcher form?  Any entered information will be lost.")) {
                this.setState({ dialogOpen: false, formOpen: false });
            }
        }
        else {
            this.setState({ dialogOpen: false, formOpen: false });
        }
    };

    reset = () => {
        this.setState({
            persons: [],
            contactDate: new Date(),
            resolutionDate: null,
            respondent: null,
            activityType: null,
            selectedActivity: '',
            consultationType: null,
            selectedConsultationId: '',
            outreachEvent: null,
            outreachComment: '',
            nctNumber: '',
            nctNumberStudyName: '',
            crtuRequest: null,
            researchMatchRequest: null,
            comment: '',
            dialogOpen: false,
            submissionSuccess: false,
            submissionError: false,
            loadResearcherError: false,
            shouldReloadPersons: false,
            contactId: 0,
            [ConsultationTypes.issueReferred]: null,
            [ConsultationTypes.consultationResearcher]: '',
            [ConsultationTypes.studyDevelopmentAssistance]: null,
            [ConsultationTypes.researchCollaborators]: '',
            [ConsultationTypes.researchSiteCollaboration]: null,
            [ConsultationTypes.clinicalTrialAssistance]: '',
            [ConsultationTypes.clinicalTrialsGovAssistance]: null,
            [ConsultationTypes.regulatoryGuidance]: null,
            respondents: null
        });

        if (this.state.addAnotherCallback) {
            this.state.addAnotherCallback();
        }

        this.componentDidMount();
    };

    renderForm(state) {
        return (
            <form onSubmit={this.handleFormSubmit}>
                <fieldset>
                    <legend>Researchers</legend>
                    <div className="row">
                        <div className="col-8">
                            <div className="mb-3">
                                <SelectResearchers title="Search for Researchers" name="researchers" value={this.state.persons} onChange={this.handlePersonsChanged} key={JSON.stringify(this.state.shouldReloadPersons)} />
                            </div>
                        </div>
                        <div className="col-4">
                            <div>
                                <label className="form-label">&nbsp;</label>
                                <div>
                                    <button type="button" className="btn btn-success" onClick={this.handleDialogOpen}>Add New Researcher</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>
                <fieldset>
                    <legend>Contact Information</legend>
                    <div className="row">
                        <div className="col-3">
                            <div className="form-group">
                                <div>
                                    <label>Date of Contact</label>
                                </div>
                                <DatePicker selected={this.state.contactDate} onChange={this.handleContactDateChanged} maxDate={this.state.resolutionDate ? this.state.resolutionDate : null} className="form-control" autoComplete="off" />
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group">
                                <div>
                                    <label>Date of Resolution</label>
                                </div>
                                <DatePicker name="resolutionDate" selected={this.state.resolutionDate} minDate={this.state.contactDate ? this.state.contactDate : null} onChange={this.handleResolutionDateChanged} className="form-control" autoComplete="off" />
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="form-group">
                                <SelectAsyncCustom name="respondents" title="OCRA Respondent" value={this.state.respondents} url={'api/contacts/get-label-entity-select-options?category=' + Constants.Respondent} onChange={option => this.setState({ respondents: option })} showManageBtn category={Constants.Respondent} isMulti />
                            </div>
                        </div>
                        {/*<div className="col-6">*/}
                        {/*    <div className="form-group">*/}
                        {/*        <SelectAsyncCustom name="respondent" title="OCRA Respondent" value={this.state.respondent} url={'api/contacts/get-label-entity-select-options?category=' + Constants.Respondent} onChange={option => { this.setState({ respondent: option }); }} showManageBtn category={Constants.Respondent} />*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <div className="form-group">
                                <SelectAsyncCustom name="activityType" title="Type of Activity" value={this.state.activityType} url={'api/contacts/get-label-entity-select-options?category=' + Constants.ActivityType} onChange={option => this.setState({ activityType: option })} />
                            </div>
                        </div>
                        {this.state.activityType && this.state.activityType.id == '7' &&
                            <div className="col-6">
                                <SelectAsyncCustom name="outreachEvent" title="OCRA Presentation/Events" value={this.state.outreachEvent} url={'api/contacts/get-label-entity-select-options?category=' + Constants.OutreachEvent} onChange={option => this.setState({ outreachEvent: option })} showManageBtn category={Constants.OutreachEvent} />
                            </div>
                        }
                        {this.state.activityType && this.state.activityType.id == '75' &&
                            <div className="col-6">
                                <TextArea name="outreachComment" value={this.state.outreachComment} label="OCRA Marketing/Outreach" onChange={this.handleInputStringChange} />
                            </div>
                        }
                        {this.state.activityType && this.state.activityType.id == '202' &&
                            <div className="col-6">
                                <SelectAsyncCustom name="crtuReqeust" title="CRTU Request" value={this.state.crtuRequest} url={'api/contacts/get-label-entity-select-options?category=' + Constants.CrtuRequest} onChange={option => this.setState({ crtuRequest: option })} showManageBtn category={Constants.CrtuRequest} isMulti />
                            </div>
                        }
                        {this.state.activityType && this.state.activityType.id == '326' &&
                            <div className="col-6">
                                <SelectAsyncCustom name="researchMatchRequest" title="ResearchMatch Request" value={this.state.researchMatchRequest} url={'api/contacts/get-label-entity-select-options?category=' + Constants.ResearchMatchRequest} onChange={option => this.setState({ researchMatchRequest: option })} showManageBtn category={Constants.ResearchMatchRequest} isMulti />
                            </div>
                        }
                        {this.state.activityType && this.state.activityType.id == '226' &&
                            <div className="col-6">
                                <InputText name="nctNumber" value={this.state.nctNumber} label="NCT#" onChange={this.handleInputStringChange} />
                            </div>
                        }
                    </div>
                </fieldset>
                {this.state.activityType && this.state.activityType.id == '4' &&
                    <fieldset>
                        <legend>Consultation Request</legend>
                        <div className="row">
                            <div className="col-6">
                                <SelectAsyncCustom name="consultationType" title="Type of Consultation" value={this.state.consultationType} url="api/contacts/get-label-entity-select-options?category=ConsultationType" onChange={option => this.setState({ consultationType: option })} />
                            </div>

                            {this.state.consultationType && this.state.consultationType.id == "8" &&
                                <div className="col-6">
                                    <SelectAsyncCustom name={ConsultationTypes.issueReferred} title={this.state.consultationType.label} value={this.state[ConsultationTypes.issueReferred]} url={'api/contacts/get-label-entity-select-options?category=' + Constants.IssueReferred} onChange={option => this.setState({ [ConsultationTypes.issueReferred]: option })} showManageBtn category={Constants.IssueReferred} isMulti />
                                </div>
                            }

                            {this.state.consultationType && this.state.consultationType.id == "9" &&
                                <div className="col-6">
                                    <InputText name={ConsultationTypes.consultationResearcher} label={this.state.consultationType.label} value={this.state[ConsultationTypes.consultationResearcher]} onChange={this.handleInputStringChange} />
                                </div>
                            }

                            {this.state.consultationType && this.state.consultationType.id == "10" &&
                                <div className="col-6">
                                    <SelectAsyncCustom name={ConsultationTypes.studyDevelopmentAssistance} title={this.state.consultationType.label} value={this.state[ConsultationTypes.studyDevelopmentAssistance]} url={'api/contacts/get-label-entity-select-options?category=' + Constants.StudyDevelopmentType} onChange={option => this.setState({ [ConsultationTypes.studyDevelopmentAssistance]: option })} showManageBtn category={Constants.StudyDevelopmentType} isMulti />
                                </div>
                            }

                            {this.state.consultationType && this.state.consultationType.id == "11" &&
                                <div className="col-6">
                                    <InputText name={ConsultationTypes.researchCollaborators} label={this.state.consultationType.label} value={this.state[ConsultationTypes.researchCollaborators]} onChange={this.handleInputStringChange} />
                                </div>
                            }

                            {this.state.consultationType && this.state.consultationType.id == "12" &&
                                <div className="col-6">
                                    <SelectAsyncCustom name={ConsultationTypes.researchSiteCollaboration} title={this.state.consultationType.label} value={this.state[ConsultationTypes.researchSiteCollaboration]} url={'api/contacts/get-label-entity-select-options?category=' + Constants.ResearchSiteCollaboration} onChange={option => this.setState({ [ConsultationTypes.researchSiteCollaboration]: option })} showManageBtn category={Constants.ResearchSiteCollaboration} isMulti />
                                </div>
                            }

                            {this.state.consultationType && this.state.consultationType.id == "13" &&
                                <div className="col-6">
                                    <InputText name={ConsultationTypes.clinicalTrialAssistance} label={this.state.consultationType.label} value={this.state[ConsultationTypes.clinicalTrialAssistance]} onChange={this.handleInputStringChange} />
                                </div>
                            }

                            {this.state.consultationType && this.state.consultationType.id == "14" &&
                                <div className="col-3">
                                    <SelectAsyncCustom name={ConsultationTypes.clinicalTrialsGovAssistance} title={this.state.consultationType.label} value={this.state[ConsultationTypes.clinicalTrialsGovAssistance]} url={'api/contacts/get-label-entity-select-options?category=' + Constants.ClinicalTrialsGovAssistance} onChange={option => this.setState({ [ConsultationTypes.clinicalTrialsGovAssistance]: option })} showManageBtn category={Constants.ClinicalTrialsGovAssistance} isMulti />
                                </div>
                            }

                            {this.state.consultationType && this.state.consultationType.id == "14" &&
                                <div className="col-3">
                                    <InputText name="nctNumberStudyName" value={this.state.nctNumberStudyName} label="NCT#/Study Name" onChange={this.handleInputStringChange} />
                                </div>
                            }

                            {this.state.consultationType && this.state.consultationType.id == "15" &&
                                <div className="col-6">
                                    <SelectAsyncCustom name={ConsultationTypes.regulatoryGuidance} title={this.state.consultationType.label} value={this.state[ConsultationTypes.regulatoryGuidance]} url={'api/contacts/get-label-entity-select-options?category=' + Constants.RegulatoryGuidance} onChange={option => this.setState({ [ConsultationTypes.regulatoryGuidance]: option })} showManageBtn category={Constants.RegulatoryGuidance} isMulti />
                                </div>
                            }

                            {this.state.consultationType && this.state.consultationType.id == "206" &&
                                <div className="col-6">
                                    <SelectAsyncCustom name={ConsultationTypes.biostatisticsAssistance} title={this.state.consultationType.label} value={this.state[ConsultationTypes.biostatisticsAssistance]} url={'api/contacts/get-label-entity-select-options?category=' + Constants.BiostatisticsAssistance} onChange={option => this.setState({ [ConsultationTypes.biostatisticsAssistance]: option })} showManageBtn category={Constants.BiostatisticsAssistance} isMulti />
                                </div>
                            }
                        </div>
                    </fieldset>
                }
                <fieldset>
                    <legend>Additional Information</legend>
                    <div className="row">
                        <div className="col-8">
                            <TextArea name="comment" rows="7" value={this.state.comment} onChange={this.handleInputStringChange} placeholder="Related comments for this contact go here..." />
                        </div>
                    </div>
                </fieldset>
                <div className="form-group">
                    <button type="submit" className="btn btn-success">{this.state.contactId ? "Update Contact" : "Add Contact"}</button>
                </div>
            </form>
        );
    }

    render() {
        if (this.state.submissionSuccess) {
            return (
                <div className="alert alert-success">
                    <p>{this.state.contactId ? "Contact successfully updated." : "Contact successfully added!"}</p>
                    {this.state.contactId ? "" : <p><button type="button" className="btn btn-outline-info" onClick={this.reset}>Add Another Contact</button></p> }
                </div>
            );
        }

        if (this.state.submissionError) {
            return (
                <div className="alert alert-danger">
                    <p>Contact failed to be added! Please try again.</p>
                    <p><a href="/contacts" className="btn btn-info">Return to Contacts List</a></p>
                </div>
            );
        }

        if (this.state.loadResearcherError) {
            return (
                <div className="alert alert-danger">
                    <p>Could not load contact with ID: {this.getContactId()}</p>
                    <p><a href="/contacts" className="btn btn-info">Return to Contacts List</a></p>
                </div>
            );
        }

        if (this.state.loadingContact) {
            return (
                <p className="alert alert-warning">Loading...</p>
            );
        }

        return (
            <div>
                {this.renderForm(this.state)}
                <Dialog disableBackdropClick open={this.state.dialogOpen} onEnter={this.handleDialogOpen} onClose={this.handleDialogClose} fullWidth={true} maxWidth="md" aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">Add Researcher</DialogTitle>
                    <DialogContent>
                        <ResearcherForm onSubmit={this.handleResearcherAdded} onAddAnother={this.handleAddAnother} />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleDialogClose} color="primary">Close</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}